/**
 * Admin 端 WebSocket 客户端 - 实时监听用户在线状态
 *
 * 连接到 Workerman 服务，接收用户上下线推送
 */

// 审计修复 #14：WS 地址统一走 src/config.js（可用 VUE_APP_WS_URL 覆盖）
import { WS_URL } from '../config'
const HTTP_HOST = WS_URL.replace(/^wss:/, 'https:').replace(/:8282$/, ':8283')
const RECONNECT_DELAY = 3000

let ws = null
let reconnectTimer = null
let heartbeatTimer = null
let isDestroyed = false
let onlineCount = 0

const listeners = {
  online: [],    // (userId) => {}
  offline: [],  // (userId) => {}
  count: [],    // (count) => {}
}

/**
 * 连接 WebSocket
 */
export function connect() {
  if (isDestroyed) return
  const token = localStorage.getItem('admin_token')
  if (!token) return

  try { ws = new WebSocket(WS_URL) } catch (e) { return scheduleReconnect() }

  ws.onopen = () => {
    console.log('[AdminWS] 已连接')
    ws.send(JSON.stringify({ type: 'auth', token, platform: 'admin' }))
  }

  ws.onmessage = (e) => {
    try {
      const msg = JSON.parse(e.data)
      handleMessage(msg)
    } catch {}
  }

  ws.onclose = () => {
    console.log('[AdminWS] 断开')
    stopHeartbeat()
    ws = null
    if (!isDestroyed) scheduleReconnect()
  }

  ws.onerror = () => {
    stopHeartbeat()
    ws = null
    if (!isDestroyed) scheduleReconnect()
  }
}

/**
 * 断开连接
 */
export function disconnect() {
  isDestroyed = true
  stopHeartbeat()
  clearTimeout(reconnectTimer)
  if (ws) { try { ws.close() } catch {}; ws = null }
}

/**
 * 获取当前在线人数
 */
export function getOnlineCount() {
  return onlineCount
}

/**
 * 注册事件监听
 * @param {'online'|'offline'|'count'} event
 * @param {Function} callback
 */
export function on(event, callback) {
  if (listeners[event]) {
    listeners[event].push(callback)
    return () => {
      listeners[event] = listeners[event].filter(cb => cb !== callback)
    }
  }
}

// ========== 内部 ==========

function handleMessage(msg) {
  switch (msg.type) {
    case 'auth_success':
      console.log('[AdminWS] 认证成功')
      startHeartbeat()
      // 连接后先拉一次总数
      fetchCount()
      break

    case 'auth_fail':
      console.warn('[AdminWS] 认证失败')
      disconnect()
      break

    case 'user_status':
      if (msg.online) {
        onlineCount++
        notify('online', msg.user_id)
      } else {
        onlineCount = Math.max(0, onlineCount - 1)
        notify('offline', msg.user_id)
      }
      notify('count', onlineCount)
      break

    case 'pong':
      break

    default:
      break
  }
}

function fetchCount() {
  fetch(HTTP_HOST + '/online-count')
    .then(r => r.json())
    .then(data => {
      if (data.code === 0) {
        onlineCount = data.data.count
        notify('count', onlineCount)
      }
    })
    .catch(() => {})
}

function startHeartbeat() {
  stopHeartbeat()
  heartbeatTimer = setInterval(() => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: 'ping' }))
    }
  }, 20000)
}

function stopHeartbeat() {
  if (heartbeatTimer) { clearInterval(heartbeatTimer); heartbeatTimer = null }
}

function scheduleReconnect() {
  clearTimeout(reconnectTimer)
  reconnectTimer = setTimeout(connect, RECONNECT_DELAY)
}

function notify(event, ...args) {
  if (listeners[event]) {
    listeners[event].forEach(cb => cb(...args))
  }
}
